export var FORM_ACTION_STATUS = /*#__PURE__*/ function(FORM_ACTION_STATUS) {
    FORM_ACTION_STATUS["PENDING"] = "pending";
    FORM_ACTION_STATUS["SUCCESS"] = "success";
    FORM_ACTION_STATUS["FAILURE"] = "failure";
    return FORM_ACTION_STATUS;
}({});

//# sourceMappingURL=form-config.js.map